import React, { useContext } from 'react'
import { ShareAltOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { VerticalContext } from 'store/verticals/Context'
import { ViewCaseGraph } from './view-case-graph/view-case-graph'
import { useNetworkGraph } from './use-network-graph'

export function NetworkGraphButton() {
  const { verticalEntity } = useContext(VerticalContext)
  const { isOpen, graphData, open, close } = useNetworkGraph()

  const entityName = verticalEntity?.entityDetails?.name || 'Entity'
  const entityId = verticalEntity?.id || ''

  return (
    <>
      <Button type='primary' icon={<ShareAltOutlined />} onClick={open}>
        Network Graph
      </Button>

      {isOpen && <ViewCaseGraph entityName={entityName} entityId={entityId} graphData={graphData} onClose={close} />}
    </>
  )
}
